import * as yup from 'yup';
import { BASE_APP_CONFIG } from '../base_app_config';

export const loginPageSchema = yup
	.object({
		imageUrl: yup.string().url().optional().default(''),
	})
	.default(BASE_APP_CONFIG.LoginPage);
